/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'brand/NG_EMAIL_FILLED': {
    width: 16,
    height: 16,
    viewBox: '0 0 101 66',
    data: '<path pid="0" _fill="currentColor" d="M61.76 59.43c17.43 0 27.69.31 33.22.58l2.09.1-.18-2.11C95.33 40.09 95 23.43 95 12.61V8.86l-5.19 4.08-1.81 1.4-34.19 28.11a14.51 14.51 0 0 1-1.93 1.41 1.8 1.8 0 0 1-.91.25h-.53l-.3.07a4.56 4.56 0 0 1-1 .11h-.5c-3.78-.38-7.51-5-12.23-10.78L35 31.69l-7.15-5.88L5.54 8.16l.74 52.06h1.84c20.24-.54 38.29-.79 53.64-.79z"/><path pid="1" _fill="currentColor" d="M14.66 9.1C20.24 13 27.82 18.61 32.2 23c1.74 1.73 3.44 3.72 4.72 5.27l.12.14 13.86 11 1.15-1.19c.54-.55 1.13-1.18 1.76-1.84 5.84-6.15 18-19 32.76-27.11l-.88-3.42H9.93z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/components/app-icons/brand/NG_EMAIL_FILLED.js